import React, { useEffect, useState } from "react";
import { Spin, Alert } from "antd";
import styled from "styled-components";
import customClientAxios from "../customAxios";

const StatsGrid = styled.div`
  display: grid; grid-template-columns: repeat(auto-fit, minmax(200px, 1fr)); gap: 16px;
  margin-bottom: 24px;
`;
const StatCard = styled.div`
  background: white; border-radius: 12px; padding: 20px 24px;
  border: 1px solid #e2e8f0;
  box-shadow: 0 1px 3px rgba(0,0,0,0.04);
`;
const StatLabel = styled.div`font-size: 12px; color: #64748b; text-transform: uppercase; letter-spacing: 0.5px; margin-bottom: 8px;`;
const StatValue = styled.div`font-size: 28px; font-weight: 600; color: #1e293b;`;

function PhotoCloudStats() {
  const [stats, setStats] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetch = async () => {
      try {
        const res = await customClientAxios().get("/admin/photo-cloud/stats");
        setStats(res.data.stats);
      } catch (e) {
        setError(e?.response?.data?.error || "Failed to load stats");
      } finally {
        setLoading(false);
      }
    };
    fetch();
  }, []);

  if (loading) return <Spin style={{ display: "block", margin: "60px auto" }} />;
  if (error) return <Alert type="error" message={error} />;
  if (!stats) return null;

  return (
    <StatsGrid>
      <StatCard><StatLabel>Total Vendors</StatLabel><StatValue>{stats.totalVendors}</StatValue></StatCard>
      <StatCard><StatLabel>Active Vendors</StatLabel><StatValue>{stats.activeVendors}</StatValue></StatCard>
      <StatCard><StatLabel>Total Galleries</StatLabel><StatValue>{stats.totalGalleries}</StatValue></StatCard>
      <StatCard><StatLabel>Published</StatLabel><StatValue>{stats.publishedGalleries}</StatValue></StatCard>
      <StatCard><StatLabel>Awaiting Review</StatLabel><StatValue>{stats.uploadedGalleries}</StatValue></StatCard>
      <StatCard><StatLabel>Total Photos</StatLabel><StatValue>{stats.totalPhotos}</StatValue></StatCard>
    </StatsGrid>
  );
}

export default PhotoCloudStats;
